import $ from 'cash-dom'
import { iosCopyToClipboard } from '../utils/ios_copy_to_clipboard'

$(document).ready(() => {
  $(".ios-install-link").on('click', (ev) => {
    ev.preventDefault()

    $("#ios_copy_el").each((_i, el) => {
      iosCopyToClipboard(el)
    })

    document.cookie = "appInstalled=true"
    window.location = "https://apps.apple.com/us/app/mix-master-miles/id1516224866"
  })

  $("#ios-close-install").on('click', (ev) => {
    ev.preventDefault()
    document.cookie = "appInstalled=true"
    $(".ios-install-banner").hide()
  })
})
